import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import focalPointApiClient from 'Services/Apis/FocalPoint/conciergeApiClient';

export const getParticipantByDocumentThunk = createAsyncThunk(
    `GetParticipantByDocumentSlicer/getParticipantByDocumentThunk`,
    async (document, { getState }) => {

        const { user } = getState().oidc;

        const headers = {
            Authorization: `Bearer ${user.access_token}`,
            campaignId: user.profile['custom:campaign_id'],
            catalogId: user.profile['custom:catalog_id'],
        };

        const { data } = await focalPointApiClient.get(
            `/Participant/${document}`,
            {
                headers,
            });
        return data;
    }
);

const initialState = {
    dataGetParticipantByDocument: {},
    loadingGetParticipantByDocument: false,
    errorGetParticipantByDocument: false,
};

const GetParticipantByDocumentSlicer = createSlice({
    name: 'GetParticipantByDocument',
    initialState,
    reducers: {
        resetDataGetParticipantByDocument: (state) => {            
            state.dataGetParticipantByDocument = {};
            state.loadingGetParticipantByDocument = false;
            state.errorGetParticipantByDocument = false;
        },
    },
    extraReducers: (builder) => {
        builder.addCase(getParticipantByDocumentThunk.pending, (state) => {
            state.dataGetParticipantByDocument = {};
            state.loadingGetParticipantByDocument = true;
            state.errorGetParticipantByDocument = false;
        });
        builder.addCase(getParticipantByDocumentThunk.fulfilled, (state, action) => {
            state.dataGetParticipantByDocument = action.payload;
            state.loadingGetParticipantByDocument = false;
            state.errorGetParticipantByDocument = false;
        });
        builder.addCase(getParticipantByDocumentThunk.rejected, (state) => {
            state.dataGetParticipantByDocument = {};
            state.loadingGetParticipantByDocument = false;
            state.errorGetParticipantByDocument = true;
        });
    },
});

export const { resetDataGetParticipantByDocument } = GetParticipantByDocumentSlicer.actions;
export default GetParticipantByDocumentSlicer.reducer;